/**
 * Merge multiple React event listeners
 *
 * @param events
 * @returns {(function(*=): void)|*}
 */
export default function mergeEvents (...events) {
	return e => {
		e.persist();
		events.forEach(event => event(e));
	};
}
